export default __webpack_public_path__ + "static/media/will_qanon_info.490a0920.jpg";